import React, { useState, useEffect } from "react";
import { postApiWithAuth } from "../../../services/api/api";
import Slider from "react-slick";

const DashboardTab = ({ userProfileData }) => {
    const [notifications, setNotifications] = useState([]);
    const [profileStatus, setProfileStatus] = useState(null);

    const matches = [
        { id: 1, name: "Pooja Sawant", city: "Mumbai", image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=600" },
        { id: 2, name: "Pooja Sawant", city: "Mumbai", image: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?q=80&w=600" },
        { id: 3, name: "Pooja Sawant", city: "Mumbai", image: "https://images.unsplash.com/photo-1517841905240-472988babdf9?q=80&w=600" },
        { id: 4, name: "Pooja Sawant", city: "Mumbai", image: "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?q=80&w=600" },
        { id: 5, name: "Pooja Sawant", city: "Mumbai", image: "https://images.unsplash.com/photo-1521572267360-ee0c2909d518?q=80&w=600" },
    ];

    const newMatches_slider = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 2 } },
            { breakpoint: 480, settings: { slidesToShow: 2 } },
        ],
    };

    // Decentralized context data loading strategy
    useEffect(() => {
        const loadDashboardData = async () => {
            try {
                const storedProfileStr = localStorage.getItem("profile_data");
                let userId = userProfileData?.id;
                if (storedProfileStr) {
                    const parsed = JSON.parse(storedProfileStr);
                    const profile = Array.isArray(parsed) ? parsed[0] : parsed;
                    userId = profile?.id || profile?.user_id || userId;
                }

                // Concurrently load notifications and dynamic metrics profiles in parallel
                const [notifResponse, statusResponse] = await Promise.all([
                    postApiWithAuth("/notification-list", { user_id: userId }),
                    postApiWithAuth("/profile-status", { user_id: userId })
                ]);

                // Bind response payload data arrays to state safely
                const list = Array.isArray(notifResponse) ? notifResponse : (notifResponse?.data || notifResponse?.notifications || []);
                setNotifications(list);

                // Rehydrate profile completion status elements safely
                if (statusResponse && (statusResponse.status || statusResponse.success)) {
                    setProfileStatus(statusResponse.data);
                }
            } catch (error) {
                console.error("Dashboard widget context error reading records:", error);
            }
        };
        loadDashboardData();
    }, [userProfileData]);

    return (
        <>
            {/*<h2 className="section-title">New Profile Matches</h2>
            <Slider {...newMatches_slider}>
                {matches.map((item) => (
                    <div key={item.id}>
                        <div className="match-card">
                            <img src={item.image} alt="" />
                            <div className="match-overlay">
                                <h5>{item.name}</h5>
                                <p>{item.city}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>*/}

            <div className="row">
                {/* Profile Status widget with live database parameters integration */}
                <div className="col-lg-4 col-6">
                    <h2 className="section-title">Profile Status</h2>
                    <div className="info-card text-center">
                        <h5 className="info_card_heading">Profile Completion</h5>
                        <div className="progress-circle">
                            <span>
                                {profileStatus?.profile_completion !== undefined
                                    ? `${profileStatus.profile_completion}%`
                                    : `${userProfileData?.profile_completion || 0}%`}
                            </span>
                        </div>
                        {/*<div className="mob-h">
                            <div className="d-flex justify-content-between mt-4">
                            <div className="d-flex react_c ">
                                <i className="fa-regular fa-handshake pro_c_icon bg_orange"></i>
                                <p>{profileStatus?.interested_count ?? 0} Interested</p>
                            </div>
                            <div className="d-flex react_c ">
                                <i className="fa-regular fa-eye pro_c_icon bg_blue"></i>
                                <p>{profileStatus?.views_count ?? 0} Views</p>
                            </div>
                        </div>
                        </div>*/}
                    </div>
                </div>

                {/* Plan Overview widget */}
                {/* <div className="col-lg-4 col-6">
                    <h2 className="section-title">Plan Details</h2>
                    <div className="info-card text-center">
                        <h5 className="info_card_heading">Standard Plan</h5>
                        <img src="assets/imgs/plan.png" alt="" className="gift-img" />
                        <h6 className="plan_heading">Plan has expired</h6>
                        <div className="mob-h">
                            <p className="plan_txt">Plan Start Date: <b>24 May 2024</b></p>
                        <p className="plan_txt">Valid till: <b>24 June 2024</b></p>
                        <button className="btn cancel-btn">Buy Now</button>
                        </div>
                    </div>
                </div> */}

                {/* Mini notification stack */}
                <div className="col-lg-8">
                    <h2 className="section-title">Notification</h2>
                    <div className="info-card">
                        {notifications.length > 0 ? (
                            notifications.slice(0, 4).map((item, index) => (
                                <div className="notification-item d-flex align-items-start" key={item.id || index}>
                                    <div className="notify-icon">i</div>
                                    <div>
                                        <h6 className="notif-title">{item.title || item.heading || "Notification"}</h6>
                                        <p className="notif-subtitle">{item.description || item.subtitle || item.message || ""}</p>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="text-muted text-center my-3">No new notifications</p>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default DashboardTab;